<template>
    <v-container grid-list-lg fluid >
        
        <v-layout row wrap >
            <v-flex lg12>
                <h3>Tareas Frecuentes</h3>
            </v-flex>

            <v-flex xs12>
                <v-container fluid grid-list-lg>
                    <v-layout row >    
                        <v-flex v-for="item in tareasFrecuentes" :key="item.title" xs4 sm3 lg3  >
                            <v-card hover >
                                <v-container fill-height fluid pa-2>
                                    <v-layout fill-height>
                                        <v-flex xs12 align-end >
                                            <svg-path-icon v-if="item.icon.startsWith('SVG_')" :name="item.icon.substring(4)"></svg-path-icon>
                                            <v-icon v-else medium v-html="item.icon"></v-icon>                                           
                                            <span >&nbsp;</span> <span class="font-weight-light" v-text="item.title"></span>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                
                                <v-card-actions>                                    
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn text icon color="red" to="" v-on="on" @click="handler(getActionFromLink(item.acciones[0].link))"> 
                                                <v-icon>favorite</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Quitar de Tareas Frecuentes</span>  
                                    </v-tooltip>
                                    <v-spacer></v-spacer>
                                    <template v-for="accion in item.acciones" >
                                        <v-btn small text color="orange" :key="accion.title" :to="accion.link"><v-icon medium>forward</v-icon>Ir</v-btn>
                                    </template>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>

        <!-- 
            <v-flex v-for="item in tareasFrecuentes" :key="item.title" lg3  >            
                <v-card class="item">
                    <v-layout>
                        <v-flex lg2 align-self-center>
                            <v-icon large v-html="item.icon"></v-icon>
                        </v-flex>
                        <v-flex lg10 align-self-center>
                            <v-card-title>
                                <div v-text="item.title"></div>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                    <v-divider ></v-divider>
                    <v-card-actions>
                        <template v-for="accion in item.acciones" >
                            <v-btn text color="orange" v-text="accion.title" :key="accion.title" :to="accion.link"></v-btn>
                        </template>
                    </v-card-actions>                   
                </v-card>
            </v-flex>        -->   
        </v-layout>
              
    </v-container>
</template>

<script>
import Vue from 'vue'
import { getTareasFrecuentesFromUiConfig } from '@/helpers/ui.js'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data: function () {
    return {      
      tareasFrecuentes: [        
        { icon: 'history', title: 'Préstamos', acciones: [{ title:'Alta', link:''}, { title:'Buscar', link:''}]},
        { icon: 'account_balance', title: 'Acuerdos', acciones: [{ title:'Alta', link:''}]},
        { icon: 'person', title: 'Caja', acciones: [{ title:'Operar', link:'/empresas-crud'}]}
      ],
    }
  },
  created () {
    this.createTareasFrecuentes()
  },
  watch: {    
    '$store.state.UiConfig' (){
      this.createTareasFrecuentes()
    },
  },
  computed: {
    ...mapGetters(['getActionFromLink']),
  },
  methods:{
    ...mapActions(['setStatusTareaFrecuente']),
      createTareasFrecuentes(){      
      // creo las tareas frecuentes en base a la configuración de la Ui ($store.UiConfig)
      this.tareasFrecuentes = getTareasFrecuentesFromUiConfig(this.$store.getters.UiConfig);
      
      if(this.$store.debugModeOn)
        Vue.$log.debug(this.tareasFrecuentes);    
    },
    handler: async function(link){
        await this.setStatusTareaFrecuente(link);
        this.createTareasFrecuentes();
    }
  }
}
</script>

<style scoped>
  
  .item {
    min-height: 110px;
    max-height: 110px;
    min-width: 80px;
    margin: 5px;
  }
</style>
